define('responsive-gameday/controllers/GameStateViewController',['require','exports','module','Responsive/controllers/ViewController','Responsive/util/renderComplete','Responsive/util/dom','Responsive/vendor','jquery','message-service/message-service','../views/Monitor/Events/ViewModelUpdateEvents','gameday-index-enums/enums/baseball/GameStates','extant/extant'],function(require,exports,module) {
	// Add private variables here
	var ViewController = require("Responsive/controllers/ViewController"),
        renderComplete = require("Responsive/util/renderComplete"),
        dom = require("Responsive/util/dom"),
        vendor = require("Responsive/vendor"),
        $ = require("jquery"),
        MessageService = require("message-service/message-service"),
        VMEvents = require("../views/Monitor/Events/ViewModelUpdateEvents"),
        GameStates = require("gameday-index-enums/enums/baseball/GameStates"),
        exists = require("extant/extant");

    var Superclass,
		isFullscreen = false,
		controlEvent = vendor.hasTouch ? 'tap' : 'mouseup',
	    //being lazy... this will be global for all instances
		fullscreenHandler = function () { },
		setFullScreenClass = function (view) {
			view.className = "fullscreen " + (isFullscreen ? "closed" : "open");
        },
        defaultStateViews = {
			"default"	: ViewController,
        	live 		: null,
        	wrapup 		: null,
        	pregame 	: null 
        };

	// Constructor
	function GameStateViewController(opts) {
		opts= exists(opts) ? opts : {};
		// Call super constructor
		Superclass.constructor.call(this);
		this.gameView = null;
		this.currentState = null;
		this.viewType = opts && opts.type || 'full';

		this.stateViews = $.extend({},defaultStateViews,opts.stateViews);
		this.allowControls = opts.allowFullscreen===true;
		this.canScroll = opts.canScroll === true;
        this.gameChanged = true;
	}

	GameStateViewController.setFullscreenHandler = function (func) {
		var that = this;
		fullscreenHandler = func && function () {
			isFullscreen = func();
			//alert(['screen',screen.availHeight,screen.availWidth].join(' :: '));
		} || fullscreenHandler;
	};

	// Prototype Inheritence
    ViewController.spawn(GameStateViewController).define({
		loadView: function () {
			var that = this;
			Superclass.loadView.call(this);
			this.showOverlay();

			if (this.allowControls) {
				if (!this.controls && fullscreenHandler) {
					this.controls = doc.createElement('div');
					this.fullscreen = doc.createElement('div');
					this.controls.className = "game_controls";
					this.controls.style.opacity = 0;
					this.controls.style[vendor.transitionJS] = "opacity 500ms ease-out 1ms";
					setFullScreenClass(this.fullscreen);
					this.fullscreen.addEventListener('click', fullscreenHandler, true);
				}
				this.controls.appendChild(this.fullscreen);
				this.getView().appendChild(this.controls);
				$(this.getView()).bind(controlEvent, function () {
					that.toggleControls();
				});
			}
		},

		viewWillAppear: function () {
			var that = this;
			Superclass.viewWillAppear.call(this);

			MessageService.addListener.call(this,VMEvents.UPDATE_GAMESTATE, this.setStateView);
		},
		viewDidAppear: function () {
			var that = this;
			Superclass.viewDidAppear.call(this);
			MessageService.publish(VMEvents.REQUEST_GAMESTATE);	
		},
		draw: function () {
			Superclass.draw.call(this);
			this.setClassName("GameStateViewController");
		},

		toggleControls: function () {
			if (this.controls) {
				setFullScreenClass(this.fullscreen);
				this.controls.style.opacity = ~~(this.controls.style.opacity) ? 0 : 1;
			}
		},
		confirmStateAccessAndFormat: function (state) {
			if (window.NATIVE && window.NATIVE.hasAccess) {
				var stateId;
				switch (state) {
					case GameStates.RE_LIVE:
						stateId = "game";
						break;
					case GameStates.RE_WRAPUP:
						stateId = "wrap";
						break;
					case GameStates.RE_PREGAME:
					default :
						stateId = "preview";
                        break;
				}
				state = window.NATIVE.hasAccess(stateId) ? state : 'live_lite';
			}
			return state.toLowerCase();
		},
		setStateView: function (payload, forced) {
			if(!this.view){
				return;
			}
			var state,
				game,
				view,
				linescore,
				that = this;


			forced = forced || false;
			game  = payload.game;

			if(game !== this.currentGame){
				forced=true;
			}

			state = this.confirmStateAccessAndFormat(payload.game_state);

			state = this.stateViews[state] ? state : (this.stateViews[this.currentState] && this.currentState || (this.stateViews.live ? "live" : "default" ));
			if (state && (state !== this.currentState || !this.gameView) || forced === true) {
				// this.gameChanged=false;
				// this.showOverlay();
				this.currentGame = game;
				this.killGameView();

				this.setClassName(state, this.currentState);
				this.currentState = state;

				view = this.gameView = this.stateViews[state] instanceof ViewController ? this.stateViews[state] : new this.stateViews[state];
				view.parentViewController = this;
				view.canScroll = this.canScroll;
				view.viewWillAppear();
				this.childViewControllers = [view];
				this.getView().appendChild(view.getView());
				view.viewDidAppear();
			}

			renderComplete(function () {
				//that.checkHeight();
				that.setAvailableHeight();
                that.hideOverlay();
			});
		},
		viewWillDisappear: function () {
			Superclass.viewWillDisappear.call(this);
			if (this.onStateChange) {
				MessageService.removeListener.call(this,VMEvents.UPDATE_GAMESTATE, this.onStateChange);
			}
			this.killGameView();
			this.currentState = null;
			this.controls = null;
			this.onStateChange = null;
			this.onGameChange = null;

		},
		killGameView: function () {
			if (this.gameView) {
				this.gameView.viewWillDisappear();
				dom.removeNode(this.getView(), this.gameView.getView());
				this.gameView.viewDidDisappear();
				this.gameView.parentViewController = null;
				this.childViewControllers = [];
				this.gameView.viewDidUnload();
				this.gameView = null;
			}

			if (this.linescore) {
				this.linescore.viewWillDisappear();
				dom.removeNode(this.getView(), this.linescore.getView());
				this.linescore.viewDidDisappear();
				this.linescore.parentViewController = null;
				this.linescore.viewDidUnload();
				this.linescore = null;
			}
		},
		setTabTitle: function () {
			if (this.parentViewController && this.parentViewController.getStatePanel) {
				this.parentViewController.getStatePanel(this.currentState);
			}
		}
	});
	Superclass = GameStateViewController.superclass;
	return GameStateViewController;
});
